import { Dialog, dialogClasses, DialogProps, styled } from "@mui/material";

const StyledDialog = styled((props: DialogProps) => <Dialog {...props} />)(
  () => ({
    [`& .${dialogClasses.paper}`]: {
      borderRadius: "8px",
    },
    [`& .${dialogClasses.paperWidthMd}`]: {
      maxWidth: "296px",
      width: "100%",
    },
    [`& .${dialogClasses.paperFullWidth}`]: {
      width: "90%",
      height: "90%",
    },
    [`& .${dialogClasses.paperFullScreen}`]: {
      borderRadius: 0,
    },
  })
);

export default StyledDialog;
